import React, { useContext } from 'react'

import { A } from '@driftt/tide-core'

import { CompanyDetailsContext } from 'context/companyDetails'

import BaseCard from '../BaseCard'
import { CardHeader,CardHeaderExpandProps } from '../CardHeader'
import EmptyCardText from '../EmptyCardText'
import { MemoReadonlyField } from '../Fields'

import DataProviderLogos from './DataProviderLogos'

import styles from './styles.module.css'

export const convertToNumber = (item: string | undefined): number | undefined => {
  if (item === undefined) {
    return undefined
  }
  const parsed = +item
  return isNaN(parsed) ? undefined : parsed
}

export const prefixUrlWithHttp = (link?: string): string | undefined => {
  if (!link) return link

  const VALID_PREFIXES = ['http://', 'https://', 'mailto:']

  for (const prefix of VALID_PREFIXES) {
    if (link.startsWith(prefix)) {
      return link
    }
  }

  return `http://${link}`
}

export const CompanyCardHeader: React.FC<CardHeaderExpandProps> = ({ ...rest }) => {
  const { companyData } = useContext(CompanyDetailsContext)

  const sources = companyData?.driftIntelSources
  return (
    <CardHeader
      data-ocweb-id="CompanyCardHeader"
      content={
        <div className={styles.companyHeaderContent}>
          <div>About</div>
          <div className={styles.providerLogosContainer}>
            {sources && <DataProviderLogos sources={sources} />}
          </div>
        </div>
      }
      {...rest}
    />
  )
}

export const CompanyCard: React.FC = () => {
  const { companyData } = useContext(CompanyDetailsContext)

  const formattedUrl = prefixUrlWithHttp(companyData?.url)
  const formattedLocation = companyData?.location
  const formattedEmployees = companyData?.employeeCount
  const formattedRevenue = companyData?.revenue

  const hasDataToDisplay =
    companyData &&
    (formattedUrl ||
      formattedLocation ||
      formattedEmployees ||
      formattedRevenue ||
      companyData.industry ||
      companyData.about)

  return (
    <BaseCard data-ocweb-id="CompanyCard">
      {!hasDataToDisplay ? (
        <EmptyCardText
          data-ocweb-id="EmptyCompanyText"
          content="We don't have any data for this company"
        />
      ) : (
        <>
          <MemoReadonlyField
            className={styles.companyDatum}
            label="Website"
            value={
              formattedUrl ? (
                <A href={formattedUrl} target="_blank" rel="noreferrer noopener">
                  {formattedUrl}
                </A>
              ) : null
            }
          />
          <MemoReadonlyField
            className={styles.companyDatum}
            label="Location"
            value={formattedLocation}
            displayWrap
          />
          <MemoReadonlyField
            className={styles.companyDatum}
            label="Employees"
            value={formattedEmployees}
          />
          <MemoReadonlyField
            className={styles.companyDatum}
            label="Category"
            value={companyData?.industry}
          />
          <MemoReadonlyField
            className={styles.companyDatum}
            label="Estimated annual revenue"
            value={formattedRevenue}
          />
          <MemoReadonlyField
            className={styles.companyDatum}
            label="About"
            value={companyData?.about}
            displayWrap
          />
        </>
      )}
    </BaseCard>
  )
}

export default CompanyCard
